import React, { useEffect } from "react";
import { Table, Button } from "reactstrap";
import ExpiringLicense from "../../components/ProgramLicense/ExpiringLicense";
import useScrollStore from "../../stores/useScrollStore";
import { useNavigate } from "react-router-dom";

function SchoolsTable({
  schools,
  toggleEditSchoolModal,
  toggleProgramLicensesModal,
}) {
  const navigate = useNavigate();
  const superuserSchoolTableScroll = useScrollStore(
    (state) => state.superuserSchoolTableScroll
  );
  const setSuperuserSchoolTableScroll = useScrollStore(
    (state) => state.setSuperuserSchoolTableScroll
  );

  useEffect(() => {
    if (superuserSchoolTableScroll !== null) {
      const rowToScrollTo = document.getElementById(
        superuserSchoolTableScroll
      );
      if (rowToScrollTo) {
        rowToScrollTo.scrollIntoView({ block: "center" });
      }
    }
  }, [superuserSchoolTableScroll]);

  const saveScrollPos = (id) => {
    setSuperuserSchoolTableScroll(id);
  };

  var mappedSchools = schools.map((school) => {
    return (
      <tr
        key={school.fortKnoxCustomerNumber}
        id={"schoolRow" + school.fortKnoxCustomerNumber}
      >
        <td className="text-center">{school.id}</td>
        <td>{school.fortKnoxCustomerNumber}</td>
        <td
          style={{
            whiteSpace: "nowrap",
            maxWidth: "400px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Button color="link" onClick={() => toggleEditSchoolModal(school)}>
            {school.name}
          </Button>
          {school.fortNoxNameDiffers ? (
            <span
              style={{ verticalAlign: "middle" }}
              title={school.fortNoxName}
            >
              ({school.fortNoxName})
            </span>
          ) : (
            ""
          )}
        </td>
        <td>{school.group ? school.group.name : ""}</td>
        <td>{school.adress.street}</td>
        <td>{school.adress.zipCode}</td>
        <td>{school.adress.city}</td>
        <td>{school.adress.country}</td>
        <td>
          <Button
            size="sm"
            outline
            color="primary"
            onClick={() => {
              toggleProgramLicensesModal(true, school);
            }}
          >
            {school.programLicenses.length || 0}
          </Button>
          <span className="ms-2">
            <ExpiringLicense
              key={school.id}
              licenses={school.programLicenses}
            />
          </span>
        </td>
        <td className="text-end">
          <Button
            size="sm"
            outline
            color="primary"
            onClick={() => {
              saveScrollPos("schoolRow" + school.fortKnoxCustomerNumber);
              navigate("/superuser/schools/programmes", {
                state: {
                  school: school,
                },
              });
            }}
          >
            {school.programmes.length}
          </Button>
        </td>
        <td className="text-end">
          <Button
            size="sm"
            outline
            color="primary"
            onClick={() => {
              saveScrollPos("schoolRow" + school.fortKnoxCustomerNumber);
              navigate("/superuser/schools/classes", {
                state: {
                  school: school,
                },
              });
            }}
          >
            {school.nbrOfClasses}
          </Button>
        </td>
        <td className="text-end">
          <Button
            size="sm"
            outline
            color="primary"
            onClick={() => {
              saveScrollPos("schoolRow" + school.fortKnoxCustomerNumber);
              navigate("/superuser/schools/teachers", {
                state: {
                  school: school,
                },
              });
            }}
          >
            {school.nbrOfTeachers}
          </Button>
        </td>
        <td className="text-end">
          <Button
            size="sm"
            outline
            color="primary"
            onClick={() => {
              saveScrollPos("schoolRow" + school.fortKnoxCustomerNumber);
              navigate("/superuser/schools/students", {
                state: {
                  school: school,
                },
              });
            }}
          >
            {school.nbrOfStudents}
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <>
      <Table
        id="school-table--container"
        hover
        responsive
        className="school-table sticky-header-table"
        style={{ verticalAlign: "middle" }}
      >
        <thead>
          <tr>
            <th className="text-center">Id</th>
            <th>Kundnummer</th>
            <th style={{ paddingLeft: "24px" }}>Namn</th>
            <th>Grupp</th>
            <th>Adress</th>
            <th>Postnummer</th>
            <th>Stad</th>
            <th>Land</th>
            <th>Programlicenser</th>
            <th>Program</th>
            <th>Klasser</th>
            <th>Lärare</th>
            <th>Elever</th>
          </tr>
        </thead>
        <tbody>{mappedSchools}</tbody>
      </Table>
    </>
  );
}

export default SchoolsTable;
